// lang-en.ts

export const LANG_EN_NAME = 'en';

export const LANG_EN_TRANS = {
  'Herramientas eléctricas y neumáticas': 'Tresna elektrikoak',

};



// WEBPACK FOOTER //
// /media/julen/a87ddcee-c364-426b-b833-77926fe0cdef/julen/Ironchip/Proyectos/dative/dative-FMOT/FMOT/src/app/translate/lang-en.ts